if ($('#globalHeader').length && $('#desktop-transactionalHeader').length) {
    SelectHeader();
}
function SelectHeader() {

    var isHome = false;
    var removeoriginurl = window.location.href.replace(window.location.origin, "");
    if (removeoriginurl.length > 1) {
        if (subwayScript.navigation.getLanguageCode().length < 1) {
            isHome = true;
        }
        var removelanguage = removeoriginurl.replace(subwayScript.navigation.getLanguageCode(), "");
        if (removelanguage.length <= 1) {
            isHome = true;
        }
    }
    else {
        isHome = true;
}
var isProfile = false;
if (window.location.href.toString().toLowerCase().includes("profile")) {
    var arr = window.location.href.toString().toLowerCase().split('/');
    var isProfileHasChildNav = arr.length > arr.indexOf('profile');
    if (arr[arr.length - 1] == "profile" || arr[arr.length - 1] == "") {
        isProfile=true;
    }
}
    var headerInit = {
        StoreId: orderViewModel.store.id,
        CartId: orderViewModel.currentOrder.cartId,
        IsHomePage: isHome
    };

subwayScript.showSpinner1();
if (isProfile) {

    $('#globalHeader').show();
    $('#globalHeader').addClass('displayHeader');
    if ($('#globalHeader').is(":visible")) {
        $('#desktop-transactionalHeader, #transactionalHeader').hide();
    }
    compNavLocation.GlobalHeaderUpdate();
    startOrderLink();
} else if ((orderViewModel.store.id != null && orderViewModel.currentOrder.cartId != null && !isHome) || isProfileHasChildNav ) {
    if ($('#globalHeader').hasClass('displayHeader')) {
        $('#globalHeader').hide();
    }
    if ($(window).width() < 1024) {
        $('#transactionalHeader').show();
    }
    $('#desktop-transactionalHeader').show();
    if (orderViewModel.orderType === "delivery")
        $('.delivery-text-link').html(orderViewModel.DeliveryAddress.StreetAddressLine1);
    else {
        $('.delivery-text-link').html(orderViewModel.store.address1);
    }
} else {

    $('#globalHeader').show();
    $('#globalHeader').addClass('displayHeader');
    if ($('#globalHeader').is(":visible")) {
        $('#desktop-transactionalHeader, #transactionalHeader').hide();
    }
    compNavLocation.GlobalHeaderUpdate();
    startOrderLink();
    }
    if (isCurrentPage('requestmissingtokens')) {
        $('.breadcrumb-Header').text($('#hdnrequestMissingtokens').val().toUpperCase())
    }

    subwayScript.hideSpinner1();
    if (orderViewModel.store.id != null && orderViewModel.currentOrder.cartId != null && !isHome) {
        
    }
}

function displayStartOrderButton() {
  if(isCurrentPage("cart")) {
    $(".show-footer-order-button-mobile-tab").remove();
  }

let windowWidth = document.documentElement.clientWidth;
let dashboardPage = false;
if ($('main#homePage').length > 0 || ($('#isDashboard').val() !== undefined && $('#isDashboard').val() === 'True')) {
    dashboardPage = true;
}

var isProfile = false;
if (window.location.href.toString().includes("profile")) {
    //  isProfile = window.location.href.toString().substring(window.location.href.toString().indexOf("profile")).length > 8;
    var arr = window.location.href.toString().split('/');
    if (arr[arr.length - 1] == "profile" || arr[arr.length - 1] == "") {
        isProfile = true
    }
    }
    var confirmOrder = isCurrentPage("confirmation");
    if (windowWidth > 1023 && (dashboardPage === false && isProfile === false && confirmOrder === false)) {
    $(".navbar-locater .start-order-btn:first").remove();
}
    else if (windowWidth >= 768 && (dashboardPage === false && isProfile === false && confirmOrder === false)) {
    $(".startorder-footer .start-order-btn").remove();
}
    else if (windowWidth < 768 && confirmOrder === true) {
      $(".startorder-only-footer,.show-footer-order-button-mobile-tab").remove();
    }
    else {
        if (dashboardPage === false && isProfile === false && confirmOrder === false) {
        $(".startorder-footer .start-order-btn").remove();
        $(".startorder-only-footer").remove();
    }
}
};
function footerStartOrder() {
    if ($('.startorder-only-footer').is(":visible") == true) {
        $('.copyright').css('margin-bottom', '60px');
    }
    }
    footerStartOrder();


$('document').ready(function(){
displayStartOrderButton();
footerStartOrder();
var windowWidth = document.documentElement.clientWidth;
if (windowWidth < 1024 && (($('#order-details-page').length == 0 && $(".display-mobile .mobile-header .deliverySectionResponsive").css("visibility") === "visible") || $("#floatingHeader ul.navigation").length)) {
    
    $(".body-top-margin").css("margin-top", $('.header-sticky').height() + 20);

}
});
